import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('customers-credit-processes', storeModule.createStoreModule('customers-credit-processes'))
